module.exports = __webpack_public_path__ + "media/universities/EDHEC-8bbf5e92.jpeg";